export enum SearchOperators {
  StartsWith = "STARTSWITH",
  Contains = "CONTAINS",
  Equals = "=",
}
